import React from "react";
import { HelpCircle, Shield } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@shared/ui/card";

const SafetyTab = ({ sopDetails }) => {
  const safetyRequirements = sopDetails?.safetyRequirements || {};
  const safetyProtocols = safetyRequirements.safetyProtocol || [];
  const safetyEquipment = safetyRequirements.safetyEquipment || [];

  return (
    <div className="mt-4 space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center pb-2">
            <Shield className="mr-2 h-5 w-5 text-primary" />
            Safety Requirements
          </CardTitle>
          <CardDescription>Required safety gear and procedures</CardDescription>
        </CardHeader>
        <CardContent>
          {/* Safety Protocols Section */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-3">Safety Protocols</h3>
            {safetyProtocols.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {safetyProtocols.map((protocol) => (
                  <div
                    key={protocol.id}
                    className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border"
                  >
                    <span className="font-medium">{protocol.name}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-4 text-muted-foreground">
                No safety protocols defined
              </div>
            )}
          </div>

          {/* Safety Equipment Section */}
          <div>
            <h3 className="text-lg font-semibold mb-3">Safety Equipment</h3>
            {safetyEquipment.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {safetyEquipment.map((equipment) => (
                  <div
                    key={equipment.id}
                    className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border"
                  >
                    <span className="font-medium">{equipment.name}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-4 text-muted-foreground">
                No safety equipment defined
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SafetyTab;
